import { CommonModule, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Component, Inject, OnDestroy, PLATFORM_ID } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { AnalyticsService } from '../../../shared/services/analytics.service';
import { JsonDataService } from '../../../shared/services/json-data.service';
import { UtilsService } from '../../../shared/services/utils.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
declare const gtag: any;
@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule,RouterModule,FormsModule,ReactiveFormsModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent implements OnDestroy {
  environment: any = environment;
  openAccordionIndex: number = -1
  menuList: any = [];
  sub:Subscription=new Subscription()
customerCareInfo:any;
  constructor(public utils: UtilsService,private jsonDataService: JsonDataService,
     @Inject(PLATFORM_ID) private platformId:Object,public dialog: MatDialog, private router: Router, public analyticsService: AnalyticsService) {
    this.sub.add(  utils.menuList.subscribe((data: any) => {
      this.menuList = []
      this.menuList = data;
    }))
    // this.getJsonData()
  }
  // getJsonData() {
  //   this.sub.add(this.jsonDataService.getCustomerCareInfoMetaJsonData().subscribe({
  //     next: (res: any) => {
  //       // this.utils.customerCareInfo = res;
  //     },
  //     error: (err: any) => {}
  //   }));
  // }  

  accordionHandler(index: number) {
    if (index == this.openAccordionIndex) {
      this.openAccordionIndex = -1;
    }
    else
      this.openAccordionIndex = index
  }

  socialMediaClickEventTrigger(icon: string) {
    const data = {
      eventName: "Social Media Icon Clicked",
      eventData: {
        'Icon Name': icon,
      }
    };
    this.analyticsService.trackData(data);
  }

  triggerSubscribeEvent() {
    if (this.utils.emailRegex.test(this.utils.subscribedEmail)) {
      this.utils.showLoading();
      // if (isPlatformBrowser(this.platformId)) {

      // (<any>window).webengage.user.setAttribute('we_email', this.utils.subscribedEmail);
      // (<any>window).webengage.user.login(this.utils.subscribedEmail);
      // }
      const data = {
        eventName: "Newsletter Subscribed",
        eventData: {
        }
      };
      this.analyticsService.trackData(data);
      if (isPlatformBrowser(this.platformId)) {

      gtag('event', 'conversion', {
        send_to: 'AW-852878965/vYljCMmn5ooDEPXM15YD',
        event_callback: 'callback  '
      });
    }
      this.utils.subscribedEmail = '';
      this.utils.openSnackBar('You have successfully subscribe to our newsletter', 'success-toster');
      this.utils.hideLoading()
    }
    else {
      this.utils.openSnackBar('Please enter a valid email', 'error-toster');
    }
  }

  // bookConsultationModal() {
  //   const dialogRef = this.dialog.open(BookConsultationComponent, {
  //     disableClose: true,
  //     data: this.utils.getUserPicode()
  //   });
  //   this.sub.add(  dialogRef.afterClosed().subscribe((res: any) => {
  //     if (res) {
  //     }
  //   }));
  // }
  ngOnDestroy(): void {

    this.sub.unsubscribe()
  }
}
